var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-editor", {
    attrs: { entity: "rumour", id: _vm.id, "new-entity": _vm.newRumour },
    on: { isDirtyChange: _vm.handleIsDirtyChange },
    scopedSlots: _vm._u(
      [
        {
          key: `editor`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.rumourEvents,
                          label: "Event",
                          "item-text": "name",
                          "item-value": "id"
                        },
                        model: {
                          value: doc.eventId,
                          callback: function($$v) {
                            _vm.$set(doc, "eventId", $$v)
                          },
                          expression: "doc.eventId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.rumourTypes,
                          label: "Rumour Type",
                          rules: [_vm.requiredRule]
                        },
                        model: {
                          value: doc.rumourType,
                          callback: function($$v) {
                            _vm.$set(doc, "rumourType", $$v)
                          },
                          expression: "doc.rumourType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Name", rules: [_vm.requiredRule] },
                        model: {
                          value: doc.name,
                          callback: function($$v) {
                            _vm.$set(doc, "name", $$v)
                          },
                          expression: "doc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("large-text-editor", {
                        attrs: { label: "Details", rules: [_vm.requiredRule] },
                        model: {
                          value: doc.description,
                          callback: function($$v) {
                            _vm.$set(doc, "description", $$v)
                          },
                          expression: "doc.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }